import { Map, YMapsApi, ObjectManager, ObjectManagerFeature, MapProps } from 'react-yandex-maps';
import {  useCallback, useContext, useEffect, useRef } from 'react';
import { StoresContext } from '../App';

export default function MapWrapper(props : MapProps) {
    const { stores } = useContext(StoresContext);
    const instance = useRef<any>();
    const apiInstance = useRef<YMapsApi>();
    const setBounds = useCallback(() => {
        const api = apiInstance.current;
        if (!api || !stores.length) {
            return;
        }
        const points = stores.map((s) => [s.lat, s.lng]);
        const bounds = api.util.bounds.fromPoints(points);
        const cz = api.util.bounds.getCenterAndZoom(bounds, instance.current.container._size);
        const zoom = cz.zoom * 0.9;
        // если карта одновременно обновляется и зумится, то некоторые точки почему-то не отображаются
        // поэтому небольшая задержка
        setTimeout(() => instance.current.setCenter(cz.center, zoom > 16 ? 16 : zoom), 100);
    }, [stores]);
    useEffect(() => {
        setBounds();
    }, [stores, setBounds]);
    const features: ObjectManagerFeature[] = [];
    for (const s of stores) {
        features.push({
            type: 'Feature',
            id: s.id,
            geometry: { type: 'Point', coordinates: [s.lat, s.lng] },
            options: {
                preset: s.product?.stock ? 'islands#redIcon' : 'islands#greenIcon',
            },
            properties: {
                balloonContent: s.balloonContent,
                hintContent: s.hintContent,
            },
        });
    }
    return (
        <Map
            modules={['layout.PieChart']}
            defaultState={{
                center: [55.751574, 37.573856],
                zoom: 5,
            }}
            instanceRef={(inst) => (instance.current = inst)}
            onLoad={(ymaps) => {
                apiInstance.current = ymaps;
                setBounds();
            }}
            {...props}
        >
            <ObjectManager
                options={{
                    clusterize: true,
                    gridSize: 100,
                }}
                objects={{
                    openBalloonOnClick: true,
                }}
                clusters={{
                    clusterIconLayout: 'default#pieChart',
                    clusterIconPieChartRadius: 25,
                    clusterIconPieChartCoreRadius: 13,
                    clusterIconPieChartStrokeWidth: 1,
                }}
                features={features}
                modules={['objectManager.addon.objectsBalloon', 'objectManager.addon.objectsHint']}
            />
        </Map>
    );
}
